import { useContext } from 'react';
import { StopwatchManager } from '../../classes/timeTracking/StopwatchManager/StopwatchManager';
import { StopwatchManagerContext } from '../../context/StopwatchManagerContext';
export function useStopwatchManager() {
  const contextValue = useContext(StopwatchManagerContext);
  return contextValue.stopwatchManager;
}